import _ from 'lodash'
const useDebounce = _.debounce

export default useDebounce
